/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignsSegments model module.
 * @module model/CampaignsSegments
 * @version 1.0.0
 */
export class CampaignsSegments {
  /**
   * Constructs a new <code>CampaignsSegments</code>.
   * @alias module:model/CampaignsSegments
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignsSegments</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignsSegments} obj Optional instance to populate.
   * @return {module:model/CampaignsSegments} The populated <code>CampaignsSegments</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignsSegments();
      if (data.hasOwnProperty('inclusions'))
        obj.inclusions = ApiClient.convertToType(data['inclusions'], ['String']);
      if (data.hasOwnProperty('exclusions'))
        obj.exclusions = ApiClient.convertToType(data['exclusions'], ['String']);
      if (data.hasOwnProperty('data'))
        obj.data = ApiClient.convertToType(data['data'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} inclusions
 */
CampaignsSegments.prototype.inclusions = undefined;

/**
 * @member {Array.<String>} exclusions
 */
CampaignsSegments.prototype.exclusions = undefined;

/**
 * @member {Array.<String>} data
 */
CampaignsSegments.prototype.data = undefined;

